module.exports = __webpack_public_path__ + "img/default-theme-right-border.75b422e2.jpg";